<template>
    <md-card class="plane-info-flight" v-if="!!plane && !!plane.flightInfos">
        <md-card-header>
            <div class="md-title">
                {{ plane.name }}
            </div>
            {{ $t('registration.slogan-pro-pilot') }}
        </md-card-header>
        <md-card-content>
            <span>
                <img src="/imgs/icons/clock.svg">
                <p
                    v-html="$t(
                        'registration.flight-time-alt',
                        {
                            flightTimeHours: plane.flightInfos.flightTimeHours,
                            flightTimeMinutes: plane.flightInfos.flightTimeMinutes
                        }
                    )"
                />
            </span>
            <span>
                <img src="/imgs/icons/clock.svg"> {{ $t('registration.estimation') }}
            </span>
            <div class="price" v-html="plane.flightInfos.priceLabelAlt" />
            <div class="mention">
                {{ $t('registration.mention') }}
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
export default {
    props: {
        planeString: {
            type: String,
        },
    },
    computed: {
        plane() {
            if (!this.planeString) {
                return;
            }

            return JSON.parse(this.planeString);
        },
    },
    created() {
        if (this.plane && this.plane.flightInfos) {
            this.plane.flightInfos.flightTimeHours   = Math.floor(this.plane.flightInfos.flightTime).toString();
            this.plane.flightInfos.flightTimeMinutes = Math.floor(
                (this.plane.flightInfos.flightTime - this.plane.flightInfos.flightTimeHours) * 60
            ).toString();

            if (this.plane.flightInfos.flightTimeMinutes.length == 1) {
                this.plane.flightInfos.flightTimeMinutes = '0' + this.plane.flightInfos.flightTimeMinutes;
            }
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/plane-info-flight.vue